import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { loginUser } from "../api";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setMessage("");

    try {
      setLoading(true);

      const data = await loginUser(email, password);

      const subscriptionStatus = String(
        data?.company?.subscription_status || ""
      )
        .trim()
        .toLowerCase();

      if (subscriptionStatus === "active" || subscriptionStatus === "trialing") {
        navigate("/dashboard");
      } else {
        navigate("/choose-plan");
      }
    } catch (error) {
      setMessage(
        error?.message ||
          "Unable to log in. Please check your email and password."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#050505",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "680px",
          background: "#0d0d0d",
          borderRadius: "28px",
          padding: "40px",
          border: "1px solid rgba(212, 175, 55, 0.45)",
          boxShadow: "0 18px 50px rgba(0,0,0,0.45)",
        }}
      >
        <h1
          style={{
            fontSize: "72px",
            fontWeight: "800",
            color: "#ffffff",
            marginBottom: "18px",
            lineHeight: 1,
          }}
        >
          Integrity Suite CRM
        </h1>

        <div
          style={{
            fontSize: "18px",
            color: "#b8b8b8",
            marginBottom: "28px",
          }}
        >
          Login to continue
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
            required
          />

          <button
            type="submit"
            style={primaryButtonStyle}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {(message || location.state?.message) ? (
          <div
            style={{
              marginTop: "20px",
              padding: "18px",
              borderRadius: "18px",
              background: "#f3f4f6",
              fontSize: "16px",
              color: "#111827",
            }}
          >
            {message || location.state?.message}
          </div>
        ) : null}

        <div
          style={{
            height: "1px",
            background: "#2b2b2b",
            margin: "30px 0 24px",
          }}
        />

        <div
          style={{
            textAlign: "center",
            color: "#b8b8b8",
            fontSize: "16px",
            marginBottom: "14px",
          }}
        >
          New to Integrity Suite?
        </div>

        <Link
          to="/register"
          style={{
            display: "block",
            width: "100%",
            padding: "17px",
            borderRadius: "18px",
            border: "1px solid #D4AF37",
            color: "#D4AF37",
            background: "#0d0d0d",
            textDecoration: "none",
            textAlign: "center",
            boxSizing: "border-box",
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          Create Account
        </Link>
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "18px 20px",
  borderRadius: "16px",
  border: "1px solid #333333",
  background: "#151515",
  color: "#ffffff",
  fontSize: "18px",
  boxSizing: "border-box",
  marginBottom: "18px",
  outline: "none",
};

const primaryButtonStyle = {
  width: "100%",
  padding: "18px",
  borderRadius: "16px",
  border: "none",
  background: "#D4AF37",
  color: "#050505",
  fontSize: "18px",
  fontWeight: "800",
  cursor: "pointer",
};
